import styled, { css } from 'styled-components';
import MaterialButton from '@mui/material/Button';
import { ButtonTheme } from '../theme/ColorSystem';

export type ColorTypes = 'default' | 'primary' | 'secondary' | 'danger' | 'warning' | 'info';

const containedCss = (color: ColorTypes) => css`
    background-color: ${ButtonTheme.active[color]};
    border-color: ${ButtonTheme.active[color]};
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);

    &:hover {
        background-color: ${ButtonTheme.hover[color]};
        border-color: ${ButtonTheme.hover[color]};
    }
    &:focus {
        background-color: ${ButtonTheme.focus[color]};
        border-color: ${ButtonTheme.focus[color]};
        outline: none;
    }
    &:disabled {
        background-color: ${ButtonTheme.disabled[color]};
        border-color: transparent;
        cursor: not-allowed;
        box-shadow: none;
        color: #fff;
    }
`;

const outlineCss = (color: ColorTypes) => css`
    border-color: ${ButtonTheme.active[color]};
    color: ${ButtonTheme.active[color]};

    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
        border-color: ${ButtonTheme.hover[color]};
        color: ${ButtonTheme.hover[color]};
    }
    &:focus {
        border-color: ${ButtonTheme.focus[color]};
        color: ${ButtonTheme.focus[color]};
        outline: none;
    }
    &:disabled,
    &[disabled] {
        border-color: ${ButtonTheme.disabled[color]};
        color: ${ButtonTheme.disabled[color]};
        opacity: 0.3;
        cursor: not-allowed;
    }
`;

export const StyledMaterialButton = styled(MaterialButton)`
    &.root {
        color: #fff;
        font-weight: 600;
        text-transform: none;
        text-align: center;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-family: sans-serif;
    }

    &.btnLarge {
        padding: 0.7rem 1rem;
        font-size: 1.25rem;
        border-radius: 100px;
        border-width: 2px;
        border-style: solid;
        height: 56px;
    }
    &.btnMedium {
        padding: 0.375rem 1rem;
        font-size: 1rem;
        border-radius: 100px;
        border-width: 2px;
        border-style: solid;
        height: 40px;
    }

    &.btnPrimaryContained {
        ${containedCss('primary')}
    }
    &.btnSecondaryContained {
        ${containedCss('secondary')}
    }
    &.btnDefaultContained {
        ${containedCss('default')}
    }
    &.btnDangerContained {
        ${containedCss('danger')}
    }
    &.btnWarningContained {
        ${containedCss('warning')}
    }
    &.btnInfoContained {
        ${containedCss('info')}
    }

    &.btnPrimaryOutline {
        ${outlineCss('primary')}
    }
    &.btnSecondaryOutline {
        ${outlineCss('secondary')}
    }
    &.btnDefaultOutline {
        ${outlineCss('default')}
    }
    &.btnDangerOutline {
        ${outlineCss('danger')}
    }
    &.btnWarningOutline {
        ${outlineCss('warning')}
    }
    &.btnInfoOutline {
        ${outlineCss('info')}
    }

    &.btnFullWidth {
        width: 100%;
    }
`;
